import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { IoSendSharp } from "react-icons/io5";
import ChatResult from "./Components/Chat/Chat";
import Sidebar from "./Components/Sidebar/Sidebar";
import "./index.scss";
import Search from "./Components/Search/Search";
import { HiOutlineCog } from "react-icons/hi";
import { FakeData } from "../FakeData/FakeData";
import DefaultChat from "./Components/DefaultChat/DefaultChat";
import { ObjectId } from 'bson';
import ReactLoading from 'react-loading';
import PeerAILogo from "../assets/images/peerai_white.png";
// import { useMsal } from "@azure/msal-react";
import ProfileDropdown  from "./ProfileDropDown";

export default function PeerAI() {
  const [data, setData] = useState([]);
  const [activeChatBot, setActiveChatBot] = useState([]);
  const [showSettings, setShowSettings] = useState(false);
  const [activeId, setActiveId] = useState("");
  const[loading,setLoading]=useState(true)
  //  const { accounts } = useMsal();
 


  // const userName = accounts[0].name;
  // const [questions,setQuestions]=useState([])
  const [config, setConfig] = useState({
    searchKeys: "",
    projectNames: [],
    temperature: 10,
    result: 1,
    isStream: true,
    cache:true
  });
  const [options, setOptions] = useState([]);
  const generateId = () => new ObjectId().toHexString();
  const handleActiveChat = (id) => {
    setActiveId(id);
    setActiveChatBot([])
  };


  const newSession = async() => {
    const response=await fetch(`${process.env.REACT_APP_API_URL}/chat_routers/createSession`,{
      method:"POST"
    })
    const data=await response.json()
    setData(prev => [...prev, data])
    setActiveId(data.session_id);
        setActiveChatBot([]);
  };

  const submitChat = (question, askData) => {
    setConfig({ ...config, searchKeys: question });
    const chatData = JSON.parse(JSON.stringify(activeChatBot));
    const updatedChatData = chatData.concat([
      {
        sender: "me",
        message: question,
      },
      {
        sender: "ai",
        message: "Loading...",
      },
    ]);
    setActiveChatBot(updatedChatData);
    if (config.isStream) {
      
      sendMessage(question, updatedChatData, askData); 
    } else {
      simulateStreaming(
        updatedChatData,
        FakeData[0].chatData[1].message,
        askData,
      );
    }
    setConfig({ ...config, searchKeys: "" });
  };

  const simulateStreaming = async (chatData, staticText, askData) => {
    const chunkSize = 50;
    const chunks = [];
    for (let i = 0; i < staticText.length; i += chunkSize) {
      chunks.push(staticText.slice(i, i + chunkSize));
    }

    let accumulatedText = "";
    const index = chatData.length - 1;

    for (const chunk of chunks) {
      await new Promise((resolve) => setTimeout(resolve, 200));

      accumulatedText += chunk;
      streamMessage(chatData, accumulatedText, index, askData);
    }
  };

  const streamMessage =async (chatData, message, index, askData,chatIdGen,question) => {
    const streamData = chatData.map((item, i) => {
      if (i === index) {
        return {
          sender: "ai",
          message: message,
          chatId:chatIdGen
        };
      }
      return item;
    });
    setActiveChatBot(streamData);
    const selectedIndex = askData.findIndex((item) => item.session_id === activeId);
    askData[selectedIndex].chatData = streamData;
    setData(askData);
    //-------------------------------------------
    
  };
  const sendMessage = async (question, chatData, askData) => {
    const index = chatData.length - 1;
    if (!question) {
      alert("Please enter a question.");
      return;
    }
    const chatIdGen=generateId();
    const payload = {
      _id:chatIdGen,
      question: question,
      projects: config.projectNames,
      top_k: config.result,
      temperature:config.temperature,
      session_id:activeId,
      cache:config.cache
    };
    console.log(payload);
    const endpoint = `${process.env.REACT_APP_API_URL}/chat_routers/chat_stream`;
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let accumulatedText = "";

      for (let done = false; !done; ) {
        const { done: streamDone, value } = await reader.read();
        done = streamDone;
        if (value) {
          const text = decoder.decode(value, { stream: true });
          accumulatedText += text;
          streamMessage(chatData, accumulatedText, index, askData,chatIdGen,question);
        }
      }

    let sessionSummary=null
    // const result = data.find(item => item.session_id === activeId);
    
    // if(!(result.session_Summary)){
      const response1 = await fetch(`${process.env.REACT_APP_API_URL}/chat_routers/shorten_question/${question}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      sessionSummary=await response1.json();      
    // }    
    setData(prevData => 
      prevData.map(item => 
        item.session_id === activeId 
          ? { ...item, session_Summary: sessionSummary }   
          : item 
      )
    );
    
    }
     catch (error) {
      streamMessage(chatData, `Error: ${error.message}`, index, askData);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && activeChatBot) {
      submitChat(config.searchKeys, data);
    }
  };

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/app_routers/projects`
      );
      const result = await response.json();
      const names = result.map((item) => item.project_name);
      setOptions(names);
      setConfig({ ...config, projectNames: [names[0]] });
    } catch (error) {
      setOptions([]);
    }
  };


  const handleDefaultChat = (question) => {
      submitChat(question, data);
  };
  const fetchSessions=async()=>{
    try{
      const response=await fetch(`${process.env.REACT_APP_API_URL}/chat_routers/getSessions`)
      const result=await response.json()
      if(result.length==0){
        newSession()
      }
      else{
      setData(result)
      }
      setActiveId(result[result.length-1].session_id)      
    }
    catch(err){
      console.log("Error in fetching sessions: ",err);
    }
    
  }

  const fetchSessionChats=async()=>{
    if(activeId!==""){
      const response= await fetch(`${process.env.REACT_APP_API_URL}/chat_routers/getChats/${activeId}`)
      const data=await response.json()      
      let chatData =[];
      data.map(item=>{
         chatData = chatData.concat([
        {
          sender: "me",
          message: item.chat.question,
        },
        {
          sender: "ai",
          message: item.chat.answer,
          chatId: item._id
        },
      ]);
      
      setActiveChatBot(chatData);
      })
      
    }
    else{
      console.log("No session Id");
    }
  }


  useEffect(() => {
    const initializeData = async () => {
      await Promise.all([fetchData(), fetchSessions()]);
      setLoading(false);
    };
    initializeData();
  }, []);

  useEffect(() => {
      fetchSessionChats()
  }, [activeId]); 
  
  // This effect runs whenever activeId changes




  return (
    (loading?
      <div className="load">
      <img src={PeerAILogo} alt="logo" />
      <ReactLoading type="bubbles" height={'10%'} width={'10%'}/>
      </div>
      :
 
    <div className="container">
      
      <Sidebar
        activeId={activeId}
        data={data}
        handleActiveChat={handleActiveChat}
        newSession={newSession}
        setData={setData}
      />
       <div style={{ position: "absolute", top: "10px", right: "20px" }}>
          <ProfileDropdown />
        </div>

      <div className="column search-column">
        {activeChatBot.length > 0 ? (
          <div className="results">
            <ChatResult activeChatBot={activeChatBot} />
          </div>
        ) : (
          <DefaultChat handleDefaultChat={handleDefaultChat} config={config} />
        )}
        <div className="search-bar">
          <div className="p-inputgroup flex-1">
            <div className="settings">
              <div
                className="cog-icon"
                onClick={() => setShowSettings(!showSettings)}
              >
                <HiOutlineCog />
              </div>
              {showSettings && (
                <div className="configs">
                  <Search
                    options={options}
                    config={config}
                    setConfig={setConfig}
                    setShowSettings={setShowSettings}
                  />
                </div>
              )}
            </div>
            <InputText
              placeholder="Ask Peer AI..."
              value={config.searchKeys}
              disabled={!activeChatBot}
              onKeyDown={handleKeyDown}
              onChange={(e) =>
                setConfig({ ...config, searchKeys: e.target.value })
              }
            />
            <div
              className="send"
              onClick={() => {
                if (activeChatBot) {
                  submitChat(config.searchKeys, data);
                }
              }}
            >
              <IoSendSharp />
            </div>
          </div>
        </div>
      </div>
    </div>
    )
  );
}

// const styles = {
//   welcomeText: {
//     position: "absolute",
//     top: "10px",
//     right: "20px",
//     fontSize: "24px",
//   },
// };

